import VueWriter from 'vue-writer'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.component('VueWriter', VueWriter);
});